var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('toast-message',{attrs:{"type":_vm.toastType,"message":_vm.toastMessage,"toggle":_vm.toastToggle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }